import React, { useEffect, useState, memo, useMemo, useLayoutEffect, useCallback } from "react";
import { checkNum10 } from "../../../modules/utils/CheckLogic";
import { closeLayerFn, openLayerFn } from "../../Layout";

export default (props) => {
  const { loading, rawSelectDate, setRawSelectDate, setLoading, checkedDate, setSelectDate, setIsCalDisplay } = props;

  useEffect(() => {
    ////일정추가 - 열기
    $(".open-add-schedule").click(function () {
      openLayerFn($(".add-date-layer"));
    });
    //닫기
    $(".add-date-layer .tbns-area a").click(function () {
      closeLayerFn($(".add-date-layer"));
    });
  }, []);
  return (
    <div className="calendar-container">
      <div className="arrows-yearmonth slide">
        <a
          className="btn-left"
          onClick={() =>
            prevMonth(
              ".year-month",
              ".dates",
              setLoading,
              $(".pick-num1").val(),
              $(".pick-num2").val()
            )
          }
        ></a>
        <span className="year-month"></span>
        <a
          className="btn-right"
          onClick={() =>
            nextMonth(
              ".year-month",
              ".dates",
              setLoading,
              $(".pick-num1").val(),
              $(".pick-num2").val()
            )
          }
        ></a>
      </div>

      <div className="calendar-slide">
        <CalendarList loading={loading} rawSelectDate={rawSelectDate} setRawSelectDate={setRawSelectDate} setLoading={setLoading} checkedDate={checkedDate} setSelectDate={setSelectDate} setIsCalDisplay={setIsCalDisplay} />
      </div>
      {/* <div className="btn-area">
                <a className="open-add-schedule">일정 추가</a>
            </div> */}
    </div>
  );
};

export const CalendarList = memo((props) => {
  const { loading, rawSelectDate, setRawSelectDate, setLoading, targetDate, checkedDate, setSelectDate, setIsCalDisplay } = props;

  const viewYear = toDay.getFullYear();
  const viewMonth = toDay.getMonth() + 1;

  const resetBoxColor = () => {
    $(".infobox").css("backgroundColor", "#fff");
  };

  useEffect(() => {
    if (checkedDate && checkedDate.length > -1) {
      goToday(
        ".year-month",
        ".dates",
        checkedDate,
        $(".pick-num1").val(),
        $(".pick-num2").val(),
        rawSelectDate
      );
    }
  }, [])
  
  useEffect(() => {
    if(loading) {
      $("li[name='calendarClick']").click(function () {
        let target;
        let selectDate =
          viewYear.toString() +
          "-" +
          checkNum10(viewMonth).toString() +
          "-" +
          ($(this).text().length < 2 ? "0" + $(this).text() : $(this).text()).toString();

          // if ($(this).text().length < 2) {
          //   let day = 0 + $(this).text();
          //   console.log("day ::: " ,day);
          // }
        
  
        $("span[name='dateSpan']").css("border", "");
        $("span[name='dateSpan']").css("borderRadius", "");
        $("span[name='dateSpan']").css("padding", "");
  
        if ($(this).attr("id") != "white") {
          // 검사예약이 있는 날짜
          target = "#span" + $(this).attr("id");
        } else {
          target = "#span" + $(this).text();
        }
        
        $(".on").removeClass("on");
        $(target).parents("li").addClass("on");
        //setSelectDate(selectDate);
  
        // 특정하기
        if ($(this).attr("id") != "white") {
          $("div[name='" + selectDate + "']").css("backgroundColor", "#d8ddf6");
        }
        
        if (rawSelectDate != selectDate) {
          setRawSelectDate(selectDate);
        }
        setIsCalDisplay(false);
      });

      setLoading(false);
    }
    
  }, [checkedDate, loading]);

  return (
    <div>
      <div className="calendar-box">
        <div>
          <ul className="week">
            <li>일</li>
            <li>월</li>
            <li>화</li>
            <li>수</li>
            <li>목</li>
            <li>금</li>
            <li>토</li>
          </ul>
          <ul className={targetDate ? targetDate : "dates"}></ul>
        </div>
      </div>
    </div>
  );
});

let toDay = new Date();

export const prevMonth = (targetTitle, targetBody, setLoading) => {
  toDay.setMonth(toDay.getMonth() - 1);

  $(".infobox").css("backgroundColor", "#fff");

  renderCalendar(targetTitle, targetBody);

  $(".pick-num1").val(
    toDay.getFullYear() + "." + checkNum10(toDay.getMonth() + 1) + "." + "01"
  );
  $(".pick-num2").val(
    toDay.getFullYear() +
      "." +
      checkNum10(toDay.getMonth() + 1) +
      "." +
      new Date(toDay.getFullYear(), toDay.getMonth() + 1, 0).getDate()
  );

  setLoading(true);
};

export const nextMonth = (targetTitle, targetBody, setLoading) => {
  toDay.setMonth(toDay.getMonth() + 1);

  $(".infobox").css("backgroundColor", "#fff");

  renderCalendar(targetTitle, targetBody);

  $(".pick-num1").val(
    toDay.getFullYear() + "." + checkNum10(toDay.getMonth() + 1) + "." + "01"
  );
  $(".pick-num2").val(
    toDay.getFullYear() +
      "." +
      checkNum10(toDay.getMonth() + 1) +
      "." +
      new Date(toDay.getFullYear(), toDay.getMonth() + 1, 0).getDate()
  );

  setLoading(true);
};

export const goToday = (
  targetTitle,
  targetBody,
  checkedDate,
  fromDate,
  toDate,
  rawSelectDate
) => {
  renderCalendar(targetTitle, targetBody, checkedDate, fromDate, toDate, rawSelectDate);
};
// 달력 생성부분
export const renderCalendar = (
  targetTitle,
  targetBody,
  checkedDate,
  fromDate,
  toDate,
  rawSelectDate
) => {
  console.log("====START====");
  if (fromDate) {
    const toDateOrg = fromDate.split(".");
    const intYear = parseInt(toDateOrg[0]);
    const intMonth = parseInt(toDateOrg[1]);
    const intDate = parseInt(toDateOrg[2]);

    // toDay = new Date(intYear, intMonth-1, intDate);
    toDay = new Date(intYear, intMonth - 1, intDate);
  }

  const viewYear = toDay.getFullYear();
  const viewMonth = toDay.getMonth();

  // // year-month 채우기
  const calendarTitle = `<em style="display:block">${viewYear} · ${
    viewMonth + 1
  }</em>`;

  document.querySelector(targetTitle).innerHTML = calendarTitle;

  // 지난 달 마지막 Date, 이번 달 마지막 Date
  const prevLast = new Date(viewYear, viewMonth, 0);
  const thisLast = new Date(viewYear, viewMonth + 1, 0);

  const PLDate = prevLast.getDate();
  const PLDay = prevLast.getDay();

  const TLDate = thisLast.getDate();
  const TLDay = thisLast.getDay();

  // // Dates 기본 배열들
  const prevDates = [];
  let thisDates = [];

  for (let cnt = 1; cnt < TLDate + 1; cnt++) {
    thisDates.push(cnt);
  }

  const nextDates = [];

  // prevDates 계산
  if (PLDay !== 6) {
    for (let i = 0; i < PLDay + 1; i++) {
      prevDates.unshift(PLDate - i);
    }
  }

  // nextDates 계산
  for (let i = 1; i < 7 - TLDay; i++) {
    nextDates.push(i);
  }

  // Dates 합치기
  const dates = prevDates.concat(thisDates, nextDates);
  let drawDates = [];

  const firstDateIndex = dates.indexOf(1);
  const lastDateIndex = dates.lastIndexOf(TLDate);

  // 스케쥴 표시 날짜
  let checkDate = [5];

  if (checkedDate && checkedDate != undefined) {
    checkDate = checkedDate;
  }

  // 날짜 클릭 이벤트
  const onClickDate = (date) => {
    alert(date);
  };

  // Dates 정리
  dates.forEach((date, i) => {
    const condition = i >= firstDateIndex && i < lastDateIndex + 1 ? "this" : "dis";

    drawDates[i] = `<li class='${condition}' id='white' name='calendarClick'><span id="span${date}" name="dateSpan">${date}</span></li>`;
  });

  // Dates 그리기
  document.querySelector(targetBody).innerHTML = drawDates.join("");

  // 오늘날짜 표시
  // "YYYY-MM-DD"
  // const today = new Date(rawSelectDate);
  // if (viewMonth === today.getMonth() && viewYear === today.getFullYear()) {
  //   for (let date of document.querySelectorAll(".this")) {
  //     if (+date.innerText === today.getDate()) {
  //       date.classList.add("on");
  //       break;
  //     }
  //   }
  // }

  console.log("====END====");
};
